// import { useState, useEffect, useContext } from 'react';
import { useEffect, useState } from 'react';
import { OptionNames } from '../types/namesList';
import axios from 'axios';

const url = new URL(window.location.href);
// const modeURL = url.searchParams.get('mode');
const getSeamless = url.searchParams.get('seamless');
const getStandartSizes = url.searchParams.get('standartSizes');
const getSignature = url.searchParams.get('signature');
const getVarnish = url.searchParams.get('varnish');
const getInstall = url.searchParams.get('install');
const getExample = url.searchParams.get('example');
const getHiddenOptions = url.searchParams.get('hidden');
const isFlipped = url.searchParams.get('isFlipped');
const urgency = url.searchParams.get('urgency');
const TDImage = url.searchParams.get('3DImage');
// const getExtraPrice = url.searchParams.get('extra');

type TOptions = {
    items: TOptionItem[];
}

type TOptionItem = {
    id: number;
    name: string;
    price: number;
    priceExtra: number;
    isPricePerMeter: boolean;
    isPercentToFullPrice: boolean;
    isPriceFromMaterial?: boolean;
    pricePropertyCode?: string;
    minPrice?: number;
    isSet: boolean;
    isHidden: boolean;
    isExtraPrice: boolean;
    isIndividualPrice: boolean;
    dataText: string;
}

export const useOptionsData = (elementId: number, paramSectionId: number) => {
    const domContainer = document.querySelector('#constructor_app'),
        // sectionId = domContainer?.getAttribute('data-section-id') ? domContainer?.getAttribute('data-section-id') : paramSectionId;
        sectionId = domContainer?.getAttribute('data-section-id')
            ? domContainer?.getAttribute('data-section-id')
            : url.searchParams.get('sectionId')
                ? url.searchParams.get('sectionId')
                : paramSectionId;

    async function getOptionsData() {
        const addParams = sectionId ? 'sectionId=' + sectionId : '';
        return await axios.get('https://fresq.ru/app/ajax/?type=options&' + addParams);
    }

    const [optionsData, setOptionsData] = useState<TOptions | null>(null);

    useEffect(() => {
        let isSubscribed = true;

        if(isSubscribed) {
            const fetchData = async () => {
                await getOptionsData()
                    .then(response => {
                            if(response.status) {
                                const hiddenOptions = getHiddenOptions?.split(',');
                                response.data.forEach((item: any) => {
                                    item.isHidden = hiddenOptions?.includes(item.name) ? true : item.isHidden;
                                    switch (item.name) {
                                        case OptionNames.Seamless:
                                            item.isSet = getSeamless ? getSeamless === 'true' : item.isSet;
                                            break;
                                        case OptionNames.StandartSizes:
                                            item.isSet = getStandartSizes ? getStandartSizes === 'true' : item.isSet;
                                            break;
                                        case OptionNames.NotStandartSizes:
                                            item.isSet = getStandartSizes ? getStandartSizes !== 'true' : item.isSet;
                                            break;
                                        case OptionNames.Signature:
                                            item.isSet = getSignature ? getSignature === 'true' : item.isSet;
                                            break;
                                        case OptionNames.Varnish:
                                            item.isSet = getVarnish ? getVarnish === 'true' : item.isSet;
                                            break;
                                        case OptionNames.Install:
                                            item.isSet = getInstall ? getInstall === 'true' : item.isSet;
                                            break;
                                        case OptionNames.Example:
                                            item.isSet = getExample ? getExample === 'true' || getExample === 'big' : item.isSet;
                                            item.isExtraPrice = getExample && getExample === 'big';
                                            break;
                                        case OptionNames.ToMirror:
                                            item.isSet = isFlipped ? isFlipped === 'true' : item.isSet;
                                            break;
                                        case OptionNames.Urgency:
                                            item.isSet = urgency ? urgency === 'true' : item.isSet;
                                            break;
                                        case OptionNames.ThreeDimensionImage:
                                            item.isSet = TDImage ? TDImage === 'true' : item.isSet;
                                            break;
                                    }
                                });

                                const newOptionsData = {
                                    items: [...response.data]
                                };

                                setOptionsData(newOptionsData);
                            }
                        }
                    );
            }

            fetchData()
                .catch(console.error);
        }

        return () => {
            isSubscribed = false;
        };
    }, [elementId, paramSectionId]);

    return [optionsData];
}